/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { Tile } from 'carbon-components-react';
import cx from 'classnames';
import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';

import BetaTag from '@ibm-watson/shared/modules/ia/components/beta-tag/BetaTag';
import { LearnMoreLink } from '../../../helpers/linkHelpers';
import { messages } from './messages';

import './TabContent.scss';

interface TabContentProps {
  /**
   *
   */
  children: JSX.Element | JSX.Element[];
  /**
   *
   */
  className?: string;
  /**
   *
   */
  title?: JSX.Element | string;
  /**
   *
   */
  subtitle?: string;
  /**
   *
   */
  imageSrc?: string;
  /**
   *
   */
  ImageComponent?: () => JSX.Element;
  /**
   *
   */
  learnMoreLink?: string;
  /**
   *
   */
  isBeta?: boolean;
}
export const TabContent = ({
  children,
  isBeta,
  subtitle,
  className,
  title,
  imageSrc,
  ImageComponent,
  learnMoreLink
}: TabContentProps) => {
  const { formatMessage: t } = useIntl();

  const IC = ImageComponent as any;

  return (
    <Tile
      className={cx(className, 'TabContent', 'TabContent__link-larger-text')}>
      {imageSrc && !ImageComponent && (
        <img
          className="TabContent__icon"
          src={imageSrc}
          alt={`${title}${t(messages.icon)}`}
          aria-hidden={true}
          title={`${title}${t(messages.icon)}`}
        />
      )}

      {ImageComponent && <IC className="TabContent__icon" />}

      <div className="TabContent__container">
        {(title || subtitle) && (
          <div className="TabContent__meta">
            {title && (
              <Fragment>
                <h3 className="TabContent__title">
                  {title} {isBeta && <BetaTag className="TabContent__beta" />}
                </h3>
              </Fragment>
            )}
            {subtitle && (
              <p className="TabContent__subtitle">
                {subtitle}{' '}
                {learnMoreLink && <LearnMoreLink url={learnMoreLink} />}
              </p>
            )}
          </div>
        )}
        {children && <div className="TabContent__body">{children}</div>}
      </div>
    </Tile>
  );
};
